import {
    Button,
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalContent,
    ModalBody,
    ModalFooter,
    Text,
    useBreakpointValue
} from '@chakra-ui/react'
import { useRef } from 'react'
import { useRender } from 'redity'
import states from './states'

export const Key = 'MODAL_FORM'

export default function ModalProvider() {
    const finalRef = useRef<any>()
    const initialRef = useRef<HTMLInputElement>()
    const render = useRender(Key)

    // Mapear tamaños del modal a versiones responsive
    const getResponsiveSize = (size: string) => {
        const sizeMap: Record<string, any> = {
            xs: { base: 'full', sm: 'xs' },
            sm: { base: 'full', sm: 'sm' },
            md: { base: 'full', sm: 'md' },
            lg: { base: 'full', sm: 'lg' },
            xl: { base: 'full', sm: 'xl' },
            '2xl': { base: 'full', sm: 'xl', md: '2xl' },
            '3xl': { base: 'full', sm: 'xl', md: '2xl', lg: '3xl' },
            '4xl': { base: 'full', sm: 'xl', md: '3xl', lg: '4xl' },
            '5xl': { base: 'full', sm: 'xl', md: '3xl', lg: '5xl' },
            '6xl': { base: 'full', sm: 'xl', md: '4xl', lg: '6xl' },
            full: 'full'
        }
        return sizeMap[size] || { base: 'full', sm: 'md' }
    }

    const modalSize = useBreakpointValue(getResponsiveSize(states.size))

    function onClose() {
        states.isOpen = false
        render()
    }

    function onOpen() {
        states.isOpen = true
        render()
    }

    return (
        <Modal
            finalFocusRef={finalRef}
            isOpen={states.isOpen}
            onClose={onClose}
            isCentered={states.isCentered}
            size={modalSize}
            closeOnOverlayClick={states.closeOnOverlayClick}
            scrollBehavior="inside"
            blockScrollOnMount={true}
            preserveScrollBarGap={true}
        >
            <ModalOverlay />
            <ModalContent
                px={{ base: 4, md: 6 }}
                py={{ base: 3, md: 4 }}
                pb={{ base: 'calc(env(safe-area-inset-bottom) + 12px)', md: 4 }}
                maxH={{ base: '100vh', md: '90vh' }}
                h={{ base: '100vh', md: 'auto' }}
                mx={{ base: 0, md: 4 }}
                my={{ base: 0, md: 'auto' }}
                borderRadius={{ base: 0, md: 'md' }}
                display="flex"
                flexDirection="column"
            >
                {!states.cleaned && states.title && (
                    <ModalHeader pb={{ base: 2, md: 4 }} flexShrink={0}>
                        <Text
                            fontSize={{
                                base: states.centerTitle ? 'xl' : 'lg',
                                sm: states.centerTitle ? '2xl' : 'xl'
                            }}
                            fontWeight={
                                states.centerTitle ? 'bold' : 'semibold'
                            }
                            textAlign={states.centerTitle ? 'center' : 'left'}
                        >
                            {states.title}
                        </Text>
                        {states.subTitle ? (
                            <Text
                                textAlign={
                                    states.centerTitle ? 'center' : 'left'
                                }
                                fontSize={{ base: 'sm', md: 'md' }}
                            >
                                {states.subTitle}
                            </Text>
                        ) : null}
                    </ModalHeader>
                )}
                <form
                    onSubmit={states.onSubmit}
                    noValidate
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        overflow: 'hidden'
                    }}
                >
                    <ModalBody
                        pb={{ base: 2, md: 6 }}
                        overflowY="auto"
                        maxH={{
                            base: 'calc(100vh - 180px)',
                            sm: 'calc(90vh - 200px)'
                        }}
                    >
                        <states.Component
                            initialRef={initialRef}
                            onClose={onClose}
                            onOpen={onOpen}
                        />
                    </ModalBody>
                    {!states.cleaned && (
                        <ModalFooter
                            pt={{ base: 2, md: 4 }}
                            pb={{ base: 2, md: 4 }}
                            px={{ base: 0, md: 6 }}
                            flexDirection={{ base: 'column', md: 'row' }}
                            gap={{ base: 2, md: 0 }}
                            flexShrink={0}
                        >
                            <Button
                                variant="alo-gray:lg-md"
                                bg="transparent"
                                color="alo-gray"
                                onClick={onClose}
                                width={{ base: 'full', md: 'auto' }}
                                fontSize={{ base: 'sm', md: 'md' }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="alo-green:lg-md"
                                ml={{ base: 0, md: 3 }}
                                type="submit"
                                isLoading={states.isLoading}
                                width={{ base: 'full', md: 'auto' }}
                                fontSize={{ base: 'sm', md: 'md' }}
                            >
                                Confirmar
                            </Button>
                        </ModalFooter>
                    )}
                </form>
            </ModalContent>
        </Modal>
    )
}
